module.exports = __webpack_public_path__ + "Icono_Ajustes_Blanco_512px.png";